module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "FileUploadWrapper"
    }
  }, [(!_vm.isLoadingData) ? _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('uploadArquivo.titulos.titulo'),
      "subTitle": _vm.$t('uploadArquivo.titulos.subtitulo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('uploadArquivo.titulos.tituloFilter')
    }
  }, [_c('div', {
    attrs: {
      "slot": "filters",
      "thumbnailWidth": "73px",
      "thumbnailHeight": "53px"
    },
    slot: "filters"
  }, [_c('dropzone', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.permissionUploadFile),
      expression: "permissionUploadFile"
    }],
    ref: "fileUploadDZ",
    attrs: {
      "id": "fileUploader",
      "url": _vm.uploadUrl,
      "use-font-awesome": "use-font-awesome",
      "duplicate-check": "duplicate-check",
      "use-custom-dropzone-options": _vm.useCustomDropzoneOptions,
      "dropzone-options": _vm.dropzoneOptions,
      "preview-template": _vm.fileListTemplate
    },
    on: {
      "vdropzone-file-added": _vm.updateQueuedFiles,
      "vdropzone-removed-file": _vm.verifyDropzoneEmpty,
      "vdropzone-error": _vm.showErrorMessage,
      "vdropzone-success": _vm.saveAuditLog
    }
  }, [(_vm.showInnerMessage) ? _c('div', {
    staticClass: "dz-inner",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('uploadArquivo.uploader.dzInnerMessage'))
    }
  }) : _vm._e(), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "layout"
    },
    domProps: {
      "value": _vm.layouts
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.permissionUploadFile),
      expression: "!permissionUploadFile"
    }],
    staticClass: "dz-default dz-message text-center upload-disabled"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-ban icon-upload-disabled"
  }), _c('p', {
    staticClass: "txt-upload-disabled",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('uploadArquivo.uploader.envioDesabilitado'))
    }
  })])])], 1)]), _c('label', {
    staticClass: "upload-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t(_vm.permissionUploadFile ? 'uploadArquivo.titulos.mensagemFilter' : 'uploadArquivo.titulos.mensagemFilterDisabled'))
    }
  })], 1)])])]) : (_vm.isLoadingData) ? _c('div', {
    staticClass: "col-md-12 col-sm-10"
  }, [_c('div', {
    staticClass: "loadingData"
  })]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-01f4a2a2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01f4a2a2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/integration/fileUpload/fileUpload.pug
// module id = 1357
// module chunks = 0